import axios from "axios";
import {
  DeviceReturn,
  ReturnInformation,
  DeviceCategoryModel,
  GetDeviceByNameReturn,
} from "./_models";

const CENTER_API_URL = process.env.REACT_APP_CENTERSERVICE_URL;
const SERVICE_API_URL = process.env.REACT_APP_SERVICE_URL;
export const GET_ALL_DEVICES = `${CENTER_API_URL}/api/v1/Device/GetAllDevice`;
export const GET_ALL_DEVICECATEGORY = `${CENTER_API_URL}/api/v1/DeviceCategory/GetAllDeviceCategory`;
export const ADD_NEW_DEVICE = `${CENTER_API_URL}/api/v1/Device/AddNewDevice`;
export const ADD_NEW_DEVICE_V2 = `${CENTER_API_URL}/api/v2/Device/AddNewDevice`;
export const GET_DEVICE_BY_NAME = `${CENTER_API_URL}/api/v1/Device/GetDeviceByName`;
export const DELETE_DEVICE = `${CENTER_API_URL}/api/v1/Device/DeleteDevice`;
export const UPDATE_DEVICE = `${CENTER_API_URL}/api/v1/Device/UpdateDevice`;
export const GET_DEVICE = `${CENTER_API_URL}/api/v1/Device/GetDeviceById`;
export const GET_OPERATIONS_BY_DEVICE = `${CENTER_API_URL}/api/v1/Operation/GetOperationsByDevice`;
export const GET_ALL_UITYPE = `${CENTER_API_URL}/api/v1/UIType/GetAllUIType`;
export const ADD_NEW_OPERATION = `${CENTER_API_URL}/api/v1/Operation/AddNewOperation`;
export const ADD_NEW_OPERATION_V2 = `${CENTER_API_URL}/api/v2/Operation/AddNewOperation`;
export const DELETE_OPERATION = `${CENTER_API_URL}/api/v1/Operation/DeleteOperation`;
export const UPDATE_OPERATION = `${CENTER_API_URL}/api/v1/Operation/UpdateOperation`;
export const UPDATE_OPERATION_V2 = `${CENTER_API_URL}/api/v2/Operation/UpdateOperation`;
export const GET_OPERATIONCOMMANDS_BY_OPERATION = `${CENTER_API_URL}/api/v1/OperationCommand/GetOperationCommandByOperationId`;
export const GET_UITYPEDEVICE_BY_UITYPE = `${CENTER_API_URL}/api/v1/UITypeDevice/GetUITypeDeviceByUIType`;
export const ADD_NEW_OPERATIONCOMMAND = `${CENTER_API_URL}/api/v1/OperationCommand/AddNewOperationCommand`;
export const ADD_NEW_OPERATIONCOMMAND_V2 = `${CENTER_API_URL}/api/v2/OperationCommand/AddNewOperationCommand`;
export const CHECK_OPERATIONCOMMAND_COUNT = `${CENTER_API_URL}/api/v1/OperationCommand/CheckOperationCommandCount`;
export const ADD_NEW_SETTING_OPERATIONCOMMAND = `${CENTER_API_URL}/api/v1/OperationCommand/AddSettingOperationCommand`;
export const DELETE_OPERATIONCOMMAND = `${CENTER_API_URL}/api/v1/OperationCommand/DeleteOperationCommand`;
export const UPDATE_OPERATIONCOMMAND = `${CENTER_API_URL}/api/v1/OperationCommand/UpdateOperationCommand`;
export const UPDATE_OPERATIONCOMMAND_V2 = `${CENTER_API_URL}/api/v2/OperationCommand/UpdateOperationCommand`;
export const GET_OPERATION_BY_ID = `${CENTER_API_URL}/api/v1/Operation/GetOperationById`;
export const GET_DEVICESERIAL_BY_DEVICEID = `${CENTER_API_URL}/api/v1/DeviceSerial/GetDeviceSerialByDevice`;
export const ADD_NEW_DEVICE_SERIAL = `${CENTER_API_URL}/api/v1/DeviceSerial/AddNewDeviceSerial`;
export const GET_SERVICE_BY_TYPE = `${SERVICE_API_URL}/api/v1/Service/GetServiceByType`;
export const GET_FREE_SERIAL_COUNT = `${CENTER_API_URL}/api/v1/DeviceSerial/GetFreeSerialCount`;
export const GET_CENTER_WALLET = `${SERVICE_API_URL}/api/v1/Payment/GetProducerCenterWallet`;
export const READ_DEVICE_JS_FILE = `${CENTER_API_URL}/api/v1/Device/ReadDeviceJsFile`;
export const GET_ALL_DEVICE_UPDATE_BY_DEVICEID = `${CENTER_API_URL}/api/v1/DeviceUpdate/GetDeviceUpdateByDeviceId`
export const ADD_NEW_DEVICE_UPDATE = `${CENTER_API_URL}/api/v1/DeviceUpdate/AddNewDeviceUpdate`
export const DELETE_DEVICE_UPDATE = `${CENTER_API_URL}/api/v1/DeviceUpdate/DeleteDeviceUpdate`
export const UPDATE_DEVICE_UPDATE = `${CENTER_API_URL}/api/v1/DeviceUpdate/UpdateDeviceUpdate`
export const UPLOAD_DEVICE_HTML_FILE = `${CENTER_API_URL}/api/v1/Device/UploadDeviceHtmlFile`
export const UPDATE_DEVICE_ANALYZER_FILE = `${CENTER_API_URL}/api/v1/Device/UpdateDeviceAnalyzerFile`
export const GET_DEVICE_VERIFY_LOG = `${CENTER_API_URL}/api/v1/Device/GetDeviceVerifyLog`
export const GET_OPERATION_GROUP_BY_DEVICE_WITH_PAGINATION = `${CENTER_API_URL}/api/v1/OperationGroup/GetAllOperationGroupByDeviceWithPagination`;
export const DELETE_OPERATION_GROUP = `${CENTER_API_URL}/api/v1/OperationGroup/DeleteOperationGroup`;
export const ADD_OPERATION_GROUP = `${CENTER_API_URL}/api/v1/OperationGroup/AddNewOperationGroup`;
export const UPDATE_OPERATION_GROUP = `${CENTER_API_URL}/api/v1/OperationGroup/UpdateOperationGroup`;
export const GET_ALL_OPERATION_BY_OPERATION_GROUP = `${CENTER_API_URL}/api/v1/Operation/GetAllOperationByOperationGroup`;
export const GET_OPERATION_GROUP_BY_DEVICE = `${CENTER_API_URL}/api/v1/OperationGroup/GetAllOperationGroupByDevice`;
export const GET_VALID_ORDER_IN_OPERATION = `${CENTER_API_URL}/api/v1/Operation/GetValidOrderInOperation`;
export const GET_ALL_DEVICE_SETTING_DETAIL = `${CENTER_API_URL}/api/v1/Device/GetAllDeviceSettingDetail`;
export const DELETE_DEVICE_SETTING_DETAIL = `${CENTER_API_URL}/api/v1/Device/DeleteDeviceSettingDetail`;
export const ADD_DEVICE_SETTING_DETAIL = `${CENTER_API_URL}/api/v1/Device/AddDeviceSettingDetail`;

export function GetAllDevices(
  page: number,
  pageSize: number,
  name: string,
  deviceCategoryId: string
) {
  let url = `${GET_ALL_DEVICES}?Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;
  if (deviceCategoryId != "")
    url = url + `&DeviceCategoryId=${deviceCategoryId}`;
  let data = axios.get<ReturnInformation<DeviceReturn>>(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetAllDeviceCategory() {
  let data = axios
    .get<ReturnInformation<Array<DeviceCategoryModel>>>(GET_ALL_DEVICECATEGORY)
    .catch((error) => {
      return error;
    });
  return data;
}

export function AddNewDevice(
  name: string,
  deviceCategoryId: string,
  producerCenterId: string,
  nodejsPathFileAnalyzeForSend,
  nodejsPathFileAnalyzeForReceive,
  analyzeType: string,
  tokenLink: string,
  link: string,
  image,
  helpFile,
  settingFile,
  sendRequestBySMSGateway,
  sendRequestDirectly,
  jsAnalyzerForSMSSend,
  jsAnalyzerForSMSReceive
) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("DeviceCategoryId", deviceCategoryId);
  bodyFormData.append("ProducerCenterId", producerCenterId);
  bodyFormData.append("NodejsFileAnalyzeForSend", nodejsPathFileAnalyzeForSend);
  bodyFormData.append("NodejsFileAnalyzeForReceive", nodejsPathFileAnalyzeForReceive);
  bodyFormData.append("AnalyzeType", analyzeType);
  bodyFormData.append("TokenLink", tokenLink);
  bodyFormData.append("Link", link);
  bodyFormData.append("Image", image);
  bodyFormData.append("HelpFile", helpFile);
  bodyFormData.append("SettingFile", settingFile);
  bodyFormData.append("SendRequestBySMSGateway", sendRequestBySMSGateway);
  bodyFormData.append("SendRequestDirectly", sendRequestDirectly);
  bodyFormData.append("JsAnalyzerForSMSSend", jsAnalyzerForSMSSend);
  bodyFormData.append("JsAnalyzerForSMSReceive", jsAnalyzerForSMSReceive);
  return axios.post(ADD_NEW_DEVICE, bodyFormData).catch((error) => {
    return error;
  });
}

export function GetDeviceByName(name: string, producerCenterId: string) {
  let data = axios
    .get<ReturnInformation<GetDeviceByNameReturn>>(
      `${GET_DEVICE_BY_NAME}?Name=${name}&ProducerCenterId=${producerCenterId}`
    )
    .catch((error) => {
      return error;
    });
  return data;
}

export function DeleteDevice(id: string) {
  let data = axios.delete(`${DELETE_DEVICE}/${id}`).catch((error) => {
    return error;
  });
  return data;
}

export function UpdateDeviceRequest(
  deviceId: string,
  name: string,
  deviceCategoryId: string,
  nodejsPathFileAnalyzeForSend,
  nodejsPathFileAnalyzeForReceive,
  analyzeType: string,
  tokenLink: string,
  link: string,
  image,
  helpFile,
  settingFile,
  sendRequestBySMSGateway,
  sendRequestDirectly,
  jsAnalyzerForSMSSend,
  jsAnalyzerForSMSReceive
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Name", name);
  bodyFormData.append("DeviceCategoryId", deviceCategoryId);
  bodyFormData.append("NodejsFileAnalyzeForSend", nodejsPathFileAnalyzeForSend);
  bodyFormData.append(
    "NodejsFileAnalyzeForReceive",
    nodejsPathFileAnalyzeForReceive
  );
  bodyFormData.append("AnalyzeType", analyzeType);
  bodyFormData.append("TokenLink", tokenLink);
  bodyFormData.append("Link", link);
  bodyFormData.append("Image", image);
  bodyFormData.append("HelpFile", helpFile);
  bodyFormData.append("SettingFile", settingFile);
  bodyFormData.append("SendRequestBySMSGateway", sendRequestBySMSGateway);
  bodyFormData.append("SendRequestDirectly", sendRequestDirectly);
  bodyFormData.append("JsAnalyzerForSMSSend", jsAnalyzerForSMSSend);
  bodyFormData.append("JsAnalyzerForSMSReceive", jsAnalyzerForSMSReceive);
  let data = axios.post(UPDATE_DEVICE, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function UpdatePartofDevice(
  deviceId: string,
  name: string,
  deviceCategoryId: string,
  analyzeType: string,
  tokenLink: string,
  link: string,
  image,
  helpFile,
  settingFile
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Name", name);
  bodyFormData.append("DeviceCategoryId", deviceCategoryId);
  bodyFormData.append("AnalyzeType", analyzeType);
  bodyFormData.append("TokenLink", tokenLink);
  bodyFormData.append("Link", link);
  bodyFormData.append("Image", image);
  bodyFormData.append("HelpFile", helpFile);
  bodyFormData.append("SettingFile", settingFile);
  let data = axios.post(UPDATE_DEVICE, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function GetDevice(deviceId: string) {
  let data = axios.get(`${GET_DEVICE}/${deviceId}`).catch((error) => {
    return error;
  });
  return data;
}

export function GetOperationsByDevice(
  deviceId: string,
  page: number,
  pageSize: number,
  name: string,
  uITypeId: string,
  type
) {
  let url = `${GET_OPERATIONS_BY_DEVICE}?DeviceId=${deviceId}&Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;
  if (uITypeId != "") url = url + `&UITypeId=${uITypeId}`;
  if (type != 10 || type != 20) url = url + `&Type=${type}`;

  let data = axios.get(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetUIType() {
  let data = axios.get(GET_ALL_UITYPE).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewOperation(
  deviceId: string,
  name: string,
  uITypeId: string,
  type,
  order
) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("UITypeId", uITypeId);
  bodyFormData.append("Type", type);
  bodyFormData.append("Order", order);
  let data = axios.post(ADD_NEW_OPERATION, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewOperationV2(
  operationGroupId: string,
  name: string,
  defaultName:string,
  uITypeId: string,
  type,
  order
) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationGroupId", operationGroupId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Type", type);
  bodyFormData.append("UITypeId", uITypeId);
  bodyFormData.append("Order", order);
  bodyFormData.append("DefaultName", defaultName);
  let data = axios.post(ADD_NEW_OPERATION_V2, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}


export function DeleteOperation(opertionId: string) {
  let data = axios
    .delete(`${DELETE_OPERATION}/${opertionId}`)
    .catch((error) => {
      return error;
    });
  return data;
}

export function UpdateOperationRequest(opertionId: string, name: string, type, order) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationId", opertionId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Type", type);
  bodyFormData.append("Order", order);
  let data = axios.post(UPDATE_OPERATION, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function UpdateOperationRequestV2(opertionId: string, name: string, type, order, operationGroupId: string,defaultName: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationId", opertionId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Type", type);
  bodyFormData.append("Order", order);
  bodyFormData.append("OperationGroupId", operationGroupId);
  bodyFormData.append("DefaultName", defaultName);
  let data = axios.post(UPDATE_OPERATION_V2, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function GetOperationCommandsByOperation(
  operationId: string,
  page: number,
  pageSize: number,
  name: string,
  command: string,
  appValue: string
) {
  let url = `${GET_OPERATIONCOMMANDS_BY_OPERATION}?OperationId=${operationId}&Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;
  if (command != "") url = url + `&Command=${command}`;
  if (appValue != "") url = url + `&AppValue=${appValue}`;
  let data = axios.get(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetUITypeDeviceByUIType(uiTypeId: string) {
  let data = axios
    .get(`${GET_UITYPEDEVICE_BY_UITYPE}?UITypeId=${uiTypeId}`)
    .catch((error) => {
      return error;
    });
  return data;
}

export function AddNewOperationCommand(
  operationId: string,
  name,
  isOption,
  command,
  appValue
) {
  var bodyFormData = new FormData();
  name.forEach((name, index) => {
    bodyFormData.append("Name", name);
    bodyFormData.append("IsOption", isOption[index]);
    bodyFormData.append("Command", command[index]);
    bodyFormData.append("AppValue", appValue[index]);
  });
  bodyFormData.append("OperationId", operationId);
  let data = axios
    .post(ADD_NEW_OPERATIONCOMMAND, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function AddNewOperationCommandV2(
  operationId: string,
  name,
  isOption,
  command,
  appValue,
  icon
) {
  var bodyFormData = new FormData();
  name.forEach((name, index) => {
    bodyFormData.append("Name", name);
    bodyFormData.append("IsOption", isOption[index]);
    bodyFormData.append("Command", command[index]);
    bodyFormData.append("AppValue", appValue[index]);
    bodyFormData.append("Icon", icon[index]);
  });
  bodyFormData.append("OperationId", operationId);
  let data = axios
    .post(ADD_NEW_OPERATIONCOMMAND_V2, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function CheckOperationCommandCount(operationId: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationId", operationId);
  let data = axios
    .post(CHECK_OPERATIONCOMMAND_COUNT, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function AddNewSettingOperationCommand(
  operationId: string,
  name: string,
  command: string
) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationId", operationId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Command", command);
  let data = axios
    .post(ADD_NEW_SETTING_OPERATIONCOMMAND, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function DeleteOperationCommand(operationCommandId: string) {
  let data = axios
    .delete(`${DELETE_OPERATIONCOMMAND}/${operationCommandId}`)
    .catch((error) => {
      return error;
    });
  return data;
}

export function UpdateOperationCommandRequest(
  operationCommandId: string,
  name: string,
  command: string,
  appValue: string,
  isOption
) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationCommandId", operationCommandId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Command", command);
  bodyFormData.append("IsOption", isOption);
  bodyFormData.append("AppValue", appValue);
  let data = axios
    .post(UPDATE_OPERATIONCOMMAND, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function UpdateOperationCommandRequestV2(
  operationCommandId: string,
  name: string,
  command: string,
  appValue: string,
  isOption,
  icon
) {
  var bodyFormData = new FormData();
  bodyFormData.append("OperationCommandId", operationCommandId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Command", command);
  bodyFormData.append("IsOption", isOption);
  bodyFormData.append("AppValue", appValue);
  bodyFormData.append("Icon", icon);
  let data = axios
    .post(UPDATE_OPERATIONCOMMAND_V2, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function GetOperationById(operationId: string) {
  let data = axios
    .get(`${GET_OPERATION_BY_ID}/${operationId}`)
    .catch((error) => {
      return error;
    });
  return data;
}

export function GetDeviceSerialByDeviceId(
  deviceId: string,
  page: number,
  pageSize: number,
  serial: string
) {
  let url = `${GET_DEVICESERIAL_BY_DEVICEID}?DeviceId=${deviceId}&Page=${page}&PageSize=${pageSize}`;
  if (serial != "") url = url + `&Serial=${serial}`;
  let data = axios.get(url).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewDeviceSerial(deviceId: string, mqttVerison, serials, deviceSecurity, connectionMethod) {
  var bodyFormData = new FormData();
  serials.forEach((serial, index) => {
    bodyFormData.append("Serials", serial);
  });
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("MQTTVersion", mqttVerison);
  bodyFormData.append("DeviceSecurity", deviceSecurity);
  bodyFormData.append("ConnectionMethod", connectionMethod);
  let data = axios.post(ADD_NEW_DEVICE_SERIAL, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function GetServiceByType(serviceType: number) {
  let url = `${GET_SERVICE_BY_TYPE}?ServiceType=${serviceType}`;
  let data = axios.get(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetFreeSerialCount(producerCenterId) {
  let url = `${GET_FREE_SERIAL_COUNT}?ProducerCenterId=${producerCenterId}`;
  let data = axios.get(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetProducerCenterWalletPrice(producerCenterId: string) {
  var url = `${GET_CENTER_WALLET}?ProducerCenterId=${producerCenterId}`;
  return axios
    .get(`${GET_CENTER_WALLET}?ProducerCenterId=${producerCenterId}`)
    .catch((error) => {
      return error;
    });
}

export function ReadDeviceJsFile(deviceId) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  let data = axios.post(READ_DEVICE_JS_FILE, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function GetDeviceUpdateByDeviceId(
  deviceId: string,
  page: number,
  pageSize: number,
  name: string,
  status,
  version: string,
  startDate,
  endDate
) {
  let url = `${GET_ALL_DEVICE_UPDATE_BY_DEVICEID}?DeviceId=${deviceId}&Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;
  if (status != 0) url = url + `&Status=${status}`;
  if (version != "") url = url + `&Version=${version}`;
  if (startDate != "") url = url + `&StartDate=${startDate}`;
  if (endDate != "") url = url + `&EndDate=${endDate}`;
  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewDeviceUpdate(
  name: string,
  deviceId: string,
  date,
  file,
  description,
  version
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Date", date);
  bodyFormData.append("File", file);
  bodyFormData.append("Description", description);
  bodyFormData.append("Version", version);
  let data = axios.post(ADD_NEW_DEVICE_UPDATE, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function DeleteDeviceUpdate(deviceUpdateId: string) {
  let url = `${DELETE_DEVICE_UPDATE}/${deviceUpdateId}`;
  let data = axios.delete(url).catch((error) => {
    return error;
  });
  return data;
}

export function UpdateDeviceUpdateRequest(
  name: string,
  deviceUpdateId: string,
  date,
  file,
  description,
  version
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceUpdateId", deviceUpdateId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Date", date);
  bodyFormData.append("File", file);
  bodyFormData.append("Description", description);
  bodyFormData.append("Version", version);
  let data = axios.post(UPDATE_DEVICE_UPDATE, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewDeviceV2(
  name: string,
  deviceCategoryId: string,
  producerCenterId: string,
  image,
  isGateway
) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("DeviceCategoryId", deviceCategoryId);
  bodyFormData.append("ProducerCenterId", producerCenterId);
  bodyFormData.append("Image", image);
  bodyFormData.append("IsGateway", isGateway);
  return axios.post(ADD_NEW_DEVICE_V2, bodyFormData).catch((error) => {
    return error;
  });
}

export function UploadDeviceHTMLFile(
  deviceId: string,
  helpFile,
  settingFile,
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("HelpFile", helpFile);
  bodyFormData.append("SettingFile", settingFile);

  return axios.post(UPLOAD_DEVICE_HTML_FILE, bodyFormData).catch((error) => {
    return error;
  });
}

export function UpdateDeviceAnalyzerFile(
  deviceId: string,
  nodejsPathFileAnalyzeForSend,
  nodejsPathFileAnalyzeForReceive,
  sendRequestBySMSGateway,
  sendRequestDirectly,
  jsAnalyzerForSMSSend,
  jsAnalyzerForSMSReceive,
  analyzeType,
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("NodejsFileAnalyzeForSend", nodejsPathFileAnalyzeForSend);
  bodyFormData.append("NodejsFileAnalyzeForReceive", nodejsPathFileAnalyzeForReceive);
  bodyFormData.append("SendRequestBySMSGateway", sendRequestBySMSGateway);
  bodyFormData.append("SendRequestDirectly", sendRequestDirectly);
  bodyFormData.append("JsAnalyzerForSMSSend", jsAnalyzerForSMSSend);
  bodyFormData.append("JsAnalyzerForSMSReceive", jsAnalyzerForSMSReceive);
  bodyFormData.append("AnalyzeType", analyzeType);
  return axios.post(UPDATE_DEVICE_ANALYZER_FILE, bodyFormData).catch((error) => {
    return error;
  });
}

export function GetDeviceVerifyLog(deviceId: string) {
  return axios.post(`${GET_DEVICE_VERIFY_LOG}?DeviceId=${deviceId}`).catch((error) => {
    return error;
  });
}


export function GetOperationGroupsByDeviceWithPagination(
  deviceId: string,
  page: number,
  pageSize: number,
  name: string,
) {
  let url = `${GET_OPERATION_GROUP_BY_DEVICE_WITH_PAGINATION}?DeviceId=${deviceId}&Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;

  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}

export function DeleteOperationGroup(opertionGroupId: string) {
  var url = `${DELETE_OPERATION_GROUP}/${opertionGroupId}`
  console.log(url)
  let data = axios.delete(url).catch((error) => {
    return error;
  });
  return data;
}

export function AddNewOperationGroup(name: string, deviceId: string, image, icon, operationGroupType, operationGroupCategory) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("Image", image);
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Icon", icon);
  bodyFormData.append("OperationGroupType", operationGroupType);
  bodyFormData.append("OperationGroupCategory", operationGroupCategory);
  let data = axios.post(ADD_OPERATION_GROUP, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function UpdateOperationGroupAPI(operationGroupId: string, name: string, image, icon, operationGroupType, operationGroupCategory) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("Image", image);
  bodyFormData.append("OperationGroupId", operationGroupId);
  bodyFormData.append("Icon", icon);
  bodyFormData.append("OperationGroupType", operationGroupType);
  bodyFormData.append("OperationGroupCategory", operationGroupCategory);
  let data = axios.post(UPDATE_OPERATION_GROUP, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function GetAllOperationByOperationGroup(
  operationGroupId: string,
  page: number,
  pageSize: number,
  name: string,
  uITypeId: string,
  type) {
  let url = `${GET_ALL_OPERATION_BY_OPERATION_GROUP}?OperationGroupId=${operationGroupId}&Page=${page}&PageSize=${pageSize}`;
  if (name != "") url = url + `&Name=${name}`;
  if (uITypeId != "") url = url + `&UITypeId=${uITypeId}`;
  if (type != 10 || type != 20) url = url + `&Type=${type}`;

  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetOperationGroupByDevice(deviceId: string) {
  return axios.post(`${GET_OPERATION_GROUP_BY_DEVICE}?DeviceId=${deviceId}`).catch((error) => {
    return error;
  });
}

export function GetValidOrderInOperation(operationGroupId: string) {
  let url = `${GET_VALID_ORDER_IN_OPERATION}?OperationGroupId=${operationGroupId}`;

  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}

export function GetAllSettingSection(deviceId: string) {
  let url = `${GET_ALL_DEVICE_SETTING_DETAIL}?DeviceId=${deviceId}`;

  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}

export function DeleteSettingSection(deviceId: string, section: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Section", section);

  let data = axios.post(DELETE_DEVICE_SETTING_DETAIL, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}

export function AddSettingSectionRequest(
  deviceId: string,
  section: string,
  name: string,
  icon,
  backgroundColor: string
) {
  var bodyFormData = new FormData();
  bodyFormData.append("DeviceId", deviceId);
  bodyFormData.append("Name", name);
  bodyFormData.append("Icon", icon);
  bodyFormData.append("Section", section);
  bodyFormData.append("BackgroundColor", backgroundColor);

  let data = axios.post(ADD_DEVICE_SETTING_DETAIL, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}